import { Phone, MessageCircle, Mail, Clock, ArrowRight } from "lucide-react";
import { SITE } from "../config/site";
import { useLead } from "../context/LeadContext";

const COLS = [
  {
    title: "Company",
    links: [
      { label: "About", href: "#why-us" },
      { label: "Services", href: "#services" },
      { label: "Why Us", href: "#why-us" },
      { label: "How It Works", href: "#how-it-works" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Cockroach Control", href: "#services" },
      { label: "Termite Control", href: "#services" },
      { label: "Bed Bug Control", href: "#services" },
      { label: "Rodent Control", href: "#services" },
      { label: "Mosquito Control", href: "#services" },
      { label: "Commercial Pest Management", href: "#services" },
    ],
  },
  {
    title: "Service Areas",
    links: [
      { label: "Delhi", href: "#areas" },
      { label: "Gurugram", href: "#areas" },
      { label: "Noida", href: "#areas" },
    ],
  },
];

export const Footer = () => {
  const { openModal } = useLead();
  return (
  <footer data-testid="site-footer" className="bg-[#141010] text-ivory/70 border-t border-ivory/10">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 lg:py-20 grid md:grid-cols-2 lg:grid-cols-5 gap-12">
      <div className="lg:col-span-2">
        <p className="font-display text-3xl font-semibold text-ivory">{SITE.companyName}</p>
        <p className="text-[11px] tracking-[0.3em] uppercase font-bold text-gold mt-1">{SITE.tagline} · Delhi NCR</p>
        <p className="text-sm leading-relaxed mt-5 max-w-xs">
          25+ years of professional pest management across Delhi, Gurugram and Noida. Free inspection. Same-day service. 100% Solution Guaranteed*.
        </p>
        <div className="mt-6 space-y-2.5 text-sm">
          <a data-testid="footer-phone" href={SITE.phoneHref} className="flex items-center gap-2.5 hover:text-gold transition-colors"><Phone className="h-4 w-4 text-gold shrink-0" /> Primary Contact: <span className="font-semibold text-ivory">{SITE.phoneDisplay}</span></a>
          <a data-testid="footer-secondary-phone" href={SITE.secondaryPhoneHref} className="flex items-center gap-2.5 hover:text-gold transition-colors"><Phone className="h-4 w-4 text-gold shrink-0" /> Additional Contact: <span className="font-semibold text-ivory">{SITE.secondaryPhoneDisplay}</span></a>
          <a data-testid="footer-whatsapp" href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-gold transition-colors"><MessageCircle className="h-4 w-4 text-gold shrink-0" /> WhatsApp: <span className="font-semibold text-ivory">{SITE.whatsappDisplay}</span></a>
          <a data-testid="footer-email" href={`mailto:${SITE.email}`} className="flex items-center gap-2.5 hover:text-gold transition-colors"><Mail className="h-4 w-4 text-gold shrink-0" /> {SITE.email}</a>
          <p className="flex items-center gap-2.5"><Clock className="h-4 w-4 text-gold shrink-0" /> {SITE.hours}</p>
        </div>
        <button
          data-testid="footer-book-btn"
          onClick={() => openModal()}
          className="mt-7 inline-flex items-center gap-2 bg-wine text-ivory px-6 py-3.5 text-[12px] font-bold tracking-[0.14em] uppercase hover:bg-wine-light transition-colors duration-300"
        >
          Book Your Free Inspection <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      {COLS.map((col) => (
        <div key={col.title}>
          <h3 className="text-[11px] tracking-[0.3em] uppercase font-bold text-ivory mb-5">{col.title}</h3>
          <ul className="space-y-3">
            {col.links.map((l) => (
              <li key={l.label}>
                <a data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} href={l.href} className="text-sm hover:text-gold transition-colors duration-300">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-ivory/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] text-ivory/40">
        <p>© {new Date().getFullYear()} {SITE.companyName}. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#top" data-testid="footer-privacy" className="hover:text-gold transition-colors">Privacy Policy</a>
          <a href="#top" data-testid="footer-terms" className="hover:text-gold transition-colors">Terms</a>
          <a href="#guarantee" data-testid="footer-guarantee-terms" className="hover:text-gold transition-colors">Guarantee Terms</a>
        </div>
      </div>
    </div>
  </footer>
  );
};
